import { useRef } from "react";
import { SnackbarProvider as NotistackProvider, SnackbarKey } from "notistack";
// @mui
import { alpha } from "@mui/material/styles";
import { Box, Collapse, Icon, IconButton } from "@mui/material";

////
import StyledNotistack from "./styles";
import ICONS from "../../assets/icons";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function SnackbarProvider({ children }: Props) {
  const notistackRef = useRef<any>(null);

  const onClose = (key: SnackbarKey) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <>
      <StyledNotistack />

      <NotistackProvider
        ref={notistackRef}
        dense
        maxSnack={5}
        preventDuplicate
        autoHideDuration={4000}
        TransitionComponent={undefined}
        variant="success" // Set default variant
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        iconVariant={{
          info: <SnackbarIcon icon="info" color="info" />,
          success: <SnackbarIcon icon="check_circle" color="success" />,
          warning: <SnackbarIcon icon="warning" color="warning" />,
          error: <SnackbarIcon icon="error" color="error" />,
        }}
        // With close as default
        action={(key: any) => (
          <IconButton size="small" onClick={onClose(key)} sx={{ p: 0.5 }}>
            <Icon>{ICONS.close}</Icon>
          </IconButton>
        )}
      >
        {children}
      </NotistackProvider>
    </>
  );
}

// ----------------------------------------------------------------------

type SnackbarIconProps = {
  icon: string | JSX.Element;
  color: "info" | "success" | "warning" | "error";
};

function SnackbarIcon({ icon, color }: SnackbarIconProps) {
  return (
    <Box
      component="span"
      sx={{
        mr: 1.5,
        width: 40,
        height: 40,
        display: "flex",
        borderRadius: 1.5,
        alignItems: "center",
        justifyContent: "center",
        color: `white`,
        bgcolor: (theme) => alpha("#fff", 0.16),
      }}
    >
      <Icon sx={{ width: 24 }}>{icon}</Icon>
    </Box>
  );
}
